"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOption = exports.OptionItem = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var icon_checkbox_blue_svg_1 = __importDefault(require("../../assets/images/icon-checkbox-blue.svg"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
exports.OptionItem = styled_components_1.default.div.attrs({
    className: 'tws-option-item',
    role: 'option',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcursor: pointer;\n\tborder-bottom: ", " ", " ", ";\n\t", "\n\t", "\n\t&:hover:not([disabled]) {\n\t\tcolor: ", ";\n\t\tbackground-color: ", " !important;\n\t\tlabel {\n\t\t\tcolor: ", " !important;\n\t\t}\n\t\t.custom-control.custom-checkbox:hover {\n\t\t\tcursor: pointer;\n\t\t\t.custom-control-input ~ .custom-control-label::before {\n\t\t\t\tborder-color: ", ";\n\t\t\t\tbackground-color: ", ";\n\t\t\t}\n\t\t}\n\t}\n\t&:last-child {\n\t\tborder-bottom: 0;\n\t}\n\t&:last-child:hover {\n\t\tborder-bottom-right-radius: 3px;\n\t\tborder-bottom-left-radius: 3px;\n\t}\n\t.tws-input-radio-wrapper {\n\t\t.custom-radio {\n\t\t\twidth: auto;\n\t\t}\n\t}\n\t.custom-control {\n\t\theight: 46px;\n\t\tpadding-left: ", ";\n\t\t&:focus {\n\t\t\toutline: 0;\n\t\t}\n\t}\n\tlabel {\n\t\t", "\n\t}\n\t> div {\n\t\tpadding: 15px 16px;\n\t\tline-height: 1.2em;\n\t\tfont-size: ", ";\n\t}\n"], ["\n\tcursor: pointer;\n\tborder-bottom: ", " ", " ", ";\n\t", "\n\t", "\n\t&:hover:not([disabled]) {\n\t\tcolor: ", ";\n\t\tbackground-color: ", " !important;\n\t\tlabel {\n\t\t\tcolor: ", " !important;\n\t\t}\n\t\t.custom-control.custom-checkbox:hover {\n\t\t\tcursor: pointer;\n\t\t\t.custom-control-input ~ .custom-control-label::before {\n\t\t\t\tborder-color: ", ";\n\t\t\t\tbackground-color: ", ";\n\t\t\t}\n\t\t}\n\t}\n\t&:last-child {\n\t\tborder-bottom: 0;\n\t}\n\t&:last-child:hover {\n\t\tborder-bottom-right-radius: 3px;\n\t\tborder-bottom-left-radius: 3px;\n\t}\n\t.tws-input-radio-wrapper {\n\t\t.custom-radio {\n\t\t\twidth: auto;\n\t\t}\n\t}\n\t.custom-control {\n\t\theight: 46px;\n\t\tpadding-left: ", ";\n\t\t&:focus {\n\t\t\toutline: 0;\n\t\t}\n\t}\n\tlabel {\n\t\t", "\n\t}\n\t> div {\n\t\tpadding: 15px 16px;\n\t\tline-height: 1.2em;\n\t\tfont-size: ", ";\n\t}\n"])), globalVars_module_scss_1.default.borderThin, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.secondaryGray2, function (props) { return (props.selected && (props.disabled === undefined || !props.disabled) ? "background-color: ".concat(globalVars_module_scss_1.default.white, ";") : null); }, function (props) {
    return props.selected
        ? "\n\t\t&:hover:not([disabled]) {\n\t\t\t.custom-control-label::before {\n\t\t\t\tbackground-color: ".concat(globalVars_module_scss_1.default.white, " !important;\n\t\t\t\tborder-color: ").concat(globalVars_module_scss_1.default.white, " !important;\n\t\t\t}\n\t\t\t.custom-control-label::after {\n\t\t\t\tborder-radius: 2px;\n\t\t\t\tbackground-image: url(").concat(icon_checkbox_blue_svg_1.default, ") !important;\n\t\t\t}\n\t\t}\n\t\t")
        : null;
}, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.mainBlue, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.spacing40, function (props) { return (props.selected ? "color: ".concat(globalVars_module_scss_1.default.mainGray, " !important;") : ''); }, globalVars_module_scss_1.default.fontSizeSmall);
exports.OptionItem.displayName = 'OptionItem';
var DisabledOptionItem = (0, styled_components_1.default)(exports.OptionItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tcolor: ", ";\n\tlabel {\n\t\t", "\n\t}\n"], ["\n\tcolor: ", ";\n\tlabel {\n\t\t", "\n\t}\n"])), globalVars_module_scss_1.default.pickerOptionTextColorDisabled, function (props) { return (props.selected ? "color: ".concat(globalVars_module_scss_1.default.gray5, " !important;") : ''); });
DisabledOptionItem.displayName = 'DisabledOptionItem';
var SelectOption = /** @class */ (function (_super) {
    __extends(SelectOption, _super);
    function SelectOption(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selected: _this.props.selected,
        };
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        return _this;
    }
    SelectOption.prototype.render = function () {
        return this.generateItem();
    };
    SelectOption.prototype.handleOnChange = function () {
        var item = __assign({}, this.props.item);
        if (this.props.onChange) {
            this.props.onChange(item, !this.props.selected);
        }
    };
    SelectOption.prototype.generateItem = function () {
        if (this.props.item && this.props.item.disabled) {
            return (React.createElement(DisabledOptionItem, { selected: this.props.selected, disabled: true }, this.props.children));
        }
        return (React.createElement(exports.OptionItem, { onClick: this.handleOnChange, selected: this.props.selected, disabled: false }, this.props.children));
    };
    SelectOption.defaultProps = {};
    return SelectOption;
}(React.Component));
exports.SelectOption = SelectOption;
var templateObject_1, templateObject_2;
